var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoCamera = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#414141",
  d: "M15.809 13.614a.486.486 0 0 1 .585-.207l.09.044 3.672 2.308c.174.11.393.114.573.012a.58.58 0 0 0 .29-.503V8.733a.58.58 0 0 0-.29-.504.56.56 0 0 0-.573.012l-3.672 2.307a.486.486 0 0 1-.675-.163.506.506 0 0 1 .16-.689L19.64 7.39a1.52 1.52 0 0 1 1.566-.034c.49.278.793.805.793 1.377v6.535c0 .571-.304 1.098-.793 1.377a1.52 1.52 0 0 1-1.566-.035l-3.672-2.307-.079-.062a.51.51 0 0 1-.081-.627"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#414141",
  d: "M15.736 8.5c0-1.38-1.098-2.5-2.453-2.5h-7.85C4.08 6 2.982 7.12 2.982 8.5v7c0 1.38 1.098 2.5 2.453 2.5h7.849c1.355 0 2.453-1.12 2.453-2.5zm.98 7c0 1.933-1.537 3.5-3.433 3.5h-7.85C3.538 19 2 17.433 2 15.5v-7C2 6.567 3.537 5 5.434 5h7.849c1.896 0 3.434 1.567 3.434 3.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoCamera);
export default ForwardRef;